// extracted by mini-css-extract-plugin
export var aircallIframe = "_mi-3";
export var fabContainer = "_mi-5";
export var fabRinging = "_mi-6";
export var loadingOverlay = "_mi-4";
export var pulse = "_mi-7";
export var widgetContent = "_mi-2";
export var widgetPanel = "_mi-0";
export var widgetPanelExpanded = "_mi-1";